import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  // Debug functions to track logo loading
  const handleLogoError = (e) => {
    console.error('❌ Logo failed to load from:', e.target.src);
    console.log('Trying alternative paths...');
    
    // Try alternative path as fallback
    setTimeout(() => {
      e.target.src = '/images/logo.png';
    }, 100);
  };

  const handleLogoLoad = () => {
    console.log('✅ Logo loaded successfully from:', '/images/logo.png');
  };

  return (
    <header className="header">
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <Link className="navbar-brand text-white" to="/">
            <img 
              src="/images/logo.png" 
              height="90" 
              className="d-inline-block align-top me-2"
              onError={handleLogoError}
              onLoad={handleLogoLoad}
              style={{ 
                border: '1px solid transparent', // Remove in production
                borderRadius: '4px'
              }}
            />
            Tailoring App
           </Link>
          
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/services">Services</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/gallery">Gallery</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">About</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/admin/login">Admin</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;